import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import { Toolbar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

// Drawer Width
export const drawerWidth = 240;

// Opened & Closed Mixins
const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

// Styled Drawer
// Use `styled(MuiDrawer)` instead of JSX inside styled
export const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    backgroundColor: "#f9f9f9",
    borderRight: `1px solid ${theme.palette.divider}`,
    ...(open && {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": {
            ...openedMixin(theme),
            backgroundColor: "#ffffff",
        },
    }),
    ...(!open && {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": {
            ...closedMixin(theme),
            backgroundColor: "#ffffff",
        },
    }),
    "& .MuiPaper-root": {
        borderRight: "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
}));

// Styled Toolbar
export const LogoToolbar = styled(Toolbar)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(1.5, 2),
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fff",
}));

// Styled Logo Image
export const LogoImage = styled("img")(({ open }) => ({
    width: open ? 140 : 40,
    height: 40,
    transition: "all 0.3s ease",
}));

// Styled List Item Button
export const StyledListItemButton = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
    minHeight: 48,
    justifyContent: "initial",
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    borderRadius: 12,
    margin: theme.spacing(0.5, 1),
    backgroundColor: active ? "#e5e5e5" : "transparent",
    "&:hover": {
        backgroundColor: active ? "#e0e0e0" : "#f5f5f5",
    },
}));

// Styled List Item Icon
export const StyledListItemIcon = styled(ListItemIcon, {
    shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
    minWidth: 0,
    marginRight: theme.spacing(3),
    justifyContent: "center",
    color: active ? theme.palette.text.primary : theme.palette.text.secondary,
}));

// Styled List Item Text
export const StyledListItemText = styled(ListItemText, {
    shouldForwardProp: (prop) => prop !== "open" && prop !== "active",
})(({ open, active }) => ({
    opacity: open ? 1 : 0,
    fontWeight: active ? 600 : 400,
}));
